import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 角色分页
    GetGridJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Role/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存角色
    Saverole({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Role/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除角色
    Deleterole({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Role/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取角色信息下拉数据
    Getrolejson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取机构下拉数据
    Getinstitution({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Organize/GetTreeSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取机构下拉数据
    GetMenu_tree({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/RoleAuthorize/GetPermissionTree', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 选中菜单列表数据
    getSelectmenulist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/RoleAuthorize/GetPermissionTree', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
